// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mb-48[data-v-712c5956]{margin-bottom:48px}.mt-16[data-v-712c5956]{margin-top:16px}.router-link[data-v-712c5956]{text-decoration:none}.dark-color[data-v-712c5956]{color:#1c1c1e}.error-list[data-v-712c5956]{padding-left:18px;margin-top:-20px;font-size:12px;color:#cb3506}", ""]);
// Exports
module.exports = exports;
